import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { SortField } from '~/utils/types/common';
import { DEFAULT_PAGE, ROWS_PER_PAGE } from '~/utils/constants/common';

import { IEquipmentList } from '~/utils/interface/equipment';
import { handleGetEquipments } from './equipmentThunk';

export interface EquipmentState {
  selectEquipments: Array<IEquipmentList>;
  filter: IFilter;
  currentPage: number;
  totalPages: number;
  needRefreshData: boolean;
  equipments: Array<IEquipmentList>;
  selectedIds: Array<string>;
  equipmentId: string;
  openAlertDelete: boolean;
  menuSelectedId: string | undefined;
}

interface IFilter {
  page?: number;
  limit?: number;
  search?: string;
  searchFields?: Array<string>;
  sort?: Array<SortField>;
}

const initialState: EquipmentState = {
  selectEquipments: [],
  currentPage: DEFAULT_PAGE,
  totalPages: 0,
  needRefreshData: false,
  filter: {
    page: 1,
    limit: ROWS_PER_PAGE,
    search: '',
    searchFields: [],
    sort: [],
  },
  selectedIds: [],
  equipments: [],
  equipmentId: '',
  openAlertDelete: false,
  menuSelectedId: undefined,
};

const equipmentSlice = createSlice({
  name: 'equipment',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    setFilter(state, action: PayloadAction<IFilter>) {
      state.filter = { ...state.filter, ...action.payload };
    },
    changeSelectedIds(state, action: PayloadAction<Array<string>>) {
      state.selectedIds = [...action.payload];
    },
    changeEquipmentId(state, action: PayloadAction<string>) {
      state.equipmentId = action.payload;
    },
    changeOpenAlertDelete(state, action: PayloadAction<boolean>) {
      state.openAlertDelete = action.payload;
      if (!state.openAlertDelete) {
        state.menuSelectedId = undefined;
      }
    },
    changeMenuSelectId(state, action: PayloadAction<string | undefined>) {
      state.menuSelectedId = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetEquipments.pending, (_state, _action) => {})

      .addCase(handleGetEquipments.fulfilled, (state, action) => {
        state.equipments = [...action.payload.responses];
        state.currentPage = action.payload.pagination.page;
        state.totalPages = action.payload.pagination.totalPages;
        state.needRefreshData = false;
      })

      .addCase(handleGetEquipments.rejected, (_state, _action) => {});
  },
});

export const equipmentActions = equipmentSlice.actions;

const equipmentReducer = equipmentSlice.reducer;
export default equipmentReducer;
